import React from "react";
import { createPortal } from "react-dom";
import Sidebar from "./Sidebar";

export default function MobileSidebarPortal({
    isOpen,
    onClose,
    onTouchStart,
    onTouchMove,
    onTouchEnd,
    sidebarProps
}) {
    return createPortal(
        <div
            className={`md:hidden fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${isOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
            onClick={onClose}
        >
            <div
                className={`absolute right-0 top-0 bottom-0 w-[280px] bg-white transform transition-transform duration-300 ease-out shadow-2xl ${isOpen ? "translate-x-0" : "translate-x-full"}`}
                onClick={(e) => e.stopPropagation()}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
            >
                <Sidebar
                    {...sidebarProps}
                    isMobile={true}
                />
            </div>
        </div>,
        document.body
    );
}
